import { render, staticRenderFns } from "./employeeGroupAction.vue?vue&type=template&id=977855c0"
import script from "./employeeGroupAction.vue?vue&type=script&lang=js"
export * from "./employeeGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports